export const sectionPageKeys = [
  'rashifal_gemini_banner_items',
  'rashifal_leo_banner_items',
  'panchang_banner_items',
  'panchang_banner_items',
  'panchang_banner_items',
  'panchang_banner_items',
  'panchang_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_virgo_banner_items',
  'panchang_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_leo_banner_items',
  'rashifal_virgo_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_cancer_banner_items',
  'rashifal_taurus_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_pisces_banner_items',
  'panchang_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_scorpio_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_sagittarius_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_capricorn_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_aries_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_aquarius_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_gemini_banner_items',
  'rashifal_pisces_banner_items',
  'rashifal_libra_banner_items',
  'rashifal_libra_banner_items',
  'store_list_page_pooja',
  'srimandir_services_page',
  'banner_large_items_slp',
  'order_history_l2_page_offerings',
  'order_history_l2_page_pooja',
  'sankalp_banners_slp',
  'remedy_list_page',
  'store_list_page_pooja_panchangam',
]

export const stepsPageKeys = [
  'payment_failed_page',
  'payment_successful_page_pooja',
  'payment_successful_page',
]

export const faqPageKeys = [
  'store_list_page',
  'cart_review_page',
  'cart_review_page_pooja',
  'store_list_page_pooja',
  'order_fulfilment_generic_faq',
  'remedy_cart_review_page_faq',
  'remedy_order_fulfilment_faq',
]

export const tutorialsPageKeys = ['store_list_page']
export const reviewsPageKeys = ['store_list_page_pooja']

export const dataTypes = [
  { value: 'info_media', label: 'Info media' },
  { value: 'info_media_web', label: 'Info media web' },
  { value: 'previous_pooja_media', label: 'Previous pooja media' },
  { value: 'banner_items', label: 'Banner items' },
  { value: 'today_importance', label: 'Today Importance' },
  { value: 'srimandir_services', label: 'Srimandir Service' },
  { value: 'glimpses_of_services', label: 'Glimpses of services' },
  { value: 'associated_temples', label: 'Associated temples' },
  { value: 'associated_pilgrims', label: 'Associated pilgrims' },
  {
    value: 'previous_order_recommendation_card',
    label: 'Previous order recommendation',
  },
  { value: 'banner_large', label: 'Banner Large' },
  { value: 'sankalp_banner', label: 'Sankalp banner' },
  { value: 'highlighted_pooja', label: 'Highlighted Pooja' },
  { value: 'declarative', label: 'Declarative' },
  { value: 'puja_stories', label: 'Puja Stories' },

  { value: 'intent_generation_banner', label: 'Intent Generation Banner' },
  {
    value: 'influencer_recommendation_banner',
    label: 'Influencer Recommendation Banner',
  },
]

export const sectionTypes = [
  { value: 'hero', label: 'Hero' },
  { value: 'category', label: 'Category' },
  { value: 'data', label: 'Data' },
  { value: 'list_item_small', label: 'List Item Small' },
  { value: 'list_item_large', label: 'List Item Large' },
  { value: 'declarative', label: 'Declarative' },
  { value: 'static_ui', label: 'Static UI' },
  { value: 'custom', label: 'custom' },
]

export const declarativeItemTypes = [
  { value: 'top_categories', label: 'Top Categories' },
  { value: 'journey_card', label: 'Journey Card' },
  { value: 'filters', label: 'Filters' },
]

export const staticUIItemTypes = [
  { value: 'festival_hero_section', label: 'Festival hero section' },
  { value: 'festival_sm_experience', label: 'Festival SM Experience' },
  { value: 'value_props', label: 'Value Props' },
  { value: 'festival_trust_marker', label: 'Festival Trust Marker' },
  { value: 'festival_services', label: 'Festival Services' },
  { value: 'all_services', label: 'All Services' },
  { value: 'text_section', label: 'Text section' },
  { value: 'top_categories_static', label: 'Top Categories Static' },
  { value: 'tithi_section', label: 'Tithi Section' },
  { value: 'content_section', label: 'Content Section' },
]

export const customItemTypes = [
  { value: 'puja_stories', label: 'Puja Stories' },
]

export const categoryItemTypes = [
  { value: 'sku', label: 'SKU' },
  { value: 'store', label: 'Store' },
  { value: 'filters', label: 'Filters' },
]

export const categoryFilterDataTypes = [
  { value: 'god', label: 'God' },
  { value: 'temple', label: 'Temple' },
  { value: 'benefits', label: 'Benefits' },
  { value: 'rashi', label: 'Rashi' },
  { value: 'moolank', label: 'Moolank' },
  { value: 'dosha', label: 'Dosha' },
  { value: 'thithi', label: 'Thithi' },
]
